import { z } from 'zod';
import { eventSchema } from './envelope';

export const SIGNAGE_PLAYLIST_UPDATED_V1 = 'signage.playlist.updated.v1' as const;

/**
 * Een playlist is gewijzigd.
 *
 * Geen enkele module luistert hiernaar, en dat is met opzet zo gelaten: een scherm **vraagt** zijn
 * playlist elke minuut opnieuw op en wordt niet gepusht. Een scherm in een kantine heeft geen
 * verbinding die je open kunt houden, en een duw die niet aankomt is onzichtbaar.
 *
 * Waarom het event er dan is: het is het spoor van wie wat wanneer op de schermen zette. Dat is de
 * vraag die een maand later gesteld wordt ("wie heeft dat erop gezet?"), en `platform.outbox`
 * bewaart rijen voor altijd.
 */
export const playlistUpdatedV1Schema = eventSchema({
  playlistId: z.guid(),
  /** `item_added`, `item_removed` of `renamed`: genoeg om het spoor te lezen. */
  change: z.enum(['created', 'item_added', 'item_removed', 'renamed']),
  changedBy: z.guid(),
  itemCount: z.number().int(),
});
export type PlaylistUpdatedV1 = z.infer<typeof playlistUpdatedV1Schema>;

export const signageEventCatalog = {
  [SIGNAGE_PLAYLIST_UPDATED_V1]: playlistUpdatedV1Schema,
} as const;
